'use client'

import dynamic from 'next/dynamic'
import { contactPageQuery } from '@otomoro/sanity/lib/queries/pages/contactPage.groq'
import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

// Re-exported components using next/dynamic ensures they're not bundled
// and sent to the browser unless actually used, with draftMode().enabled.

const ContactPage = dynamic(() => import('./ContactPage'))

export default function ContactPagePreview({
  initial,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    contactPageQuery,
    {},
    { initial }
  );

	return data ? (
    <ContactPage data={data as any} />
  ) : (
    <div className="bg-red-100">No page found</div>
  );
}
